import appConfig from '../../appConfig';

type TrackingMetadataResult = {
  app_version?: string | null;
  browser_height?: number;
  browser_width?: number;
  pixel_ratio?: number;
  url?: string;
};

const trackingMetadata = (): TrackingMetadataResult => {
  const windowEvents =
    typeof window === 'undefined'
      ? {}
      : {
          app_version: appConfig.appBuildId || null,
          url: window.location.href,
          browser_height: window.innerHeight || 0,
          browser_width: window.innerWidth || 0,
          pixel_ratio: window.devicePixelRatio || 0,
        };

  return windowEvents;
};

export default trackingMetadata;
